var render, staticRenderFns
import script from "./feather.vue?vue&type=script&lang=js&"
export * from "./feather.vue?vue&type=script&lang=js&"
import style0 from "./feather.vue?vue&type=style&index=0&id=371640c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371640c4",
  null
  
)

export default component.exports